export default __webpack_public_path__ + "static/media/tarra-logotype-l.bebfbfd8.svg";